var React = require('react');

function PlusWhite (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icons/Minor/Plus/White"),React.createElement("path",{"d":"M9 9v3a1 1 0 0 1-2 0V9H4a1 1 0 0 1 0-2h3V4a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2H9z","fill":"#FFF","fillOpacity":".5","key":1})]);
}

PlusWhite.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = PlusWhite;

PlusWhite.default = PlusWhite;
